import React from "react";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ChatbotWidget from "@/components/ChatbotWidget";
import { CmsEditBanner } from "@/components/cms/CmsEditButtons";
import FloatingCmsButtons from "@/components/cms/FloatingCmsButtons";
import FloatingLanguageSwitcher from "@/components/FloatingLanguageSwitcher";
import AutoImageEditor from "@/components/cms/AutoImageEditor";
import AutoTextEditor from "@/components/cms/AutoTextEditor";
import XalucaLogoOverlay from "@/components/XalucaLogoOverlay";
import TopBanner from "@/components/TopBanner";
import { MusicPlayerProvider } from "@/contexts/MusicPlayerContext";
import { AudioGuideProvider } from "@/contexts/AudioGuideContext";
import FloatingAudioPlayer from "@/components/FloatingAudioPlayer";
import { useLocation } from "react-router-dom";

// The TopBanner (h-9 = 36px) sits ABOVE the main Header (h-20 = 80px).
// Both are fixed, so the main content needs to be pushed down by the sum:
// 36 + 80 = 116px (= pt-29 — Tailwind's `pt-[116px]` arbitrary).
const Layout = ({ children }) => {
  // Hide the floating language switcher on admin routes — those are
  // internal tools, not brand pages, and the switcher would just
  // clutter the editor UI.
  const { pathname } = useLocation();
  const isAdminPath = /^\/admin(\/|$)/.test(pathname || "");

  return (
    <MusicPlayerProvider>
      <AudioGuideProvider>
        <div className="min-h-screen flex flex-col bg-[#FDFBF7] text-[#2C2621]">
          <CmsEditBanner />
          <TopBanner />
          <Header />
          <main className="flex-1 pt-[116px]">{children}</main>
          <Footer />
          <FloatingCmsButtons />
          {!isAdminPath && <FloatingLanguageSwitcher />}
          <ChatbotWidget />
          <AutoImageEditor />
          <AutoTextEditor />
          <XalucaLogoOverlay />
          <FloatingAudioPlayer />
          {/* Global toast surface — single source of truth for every
              page. Historically each page mounted its own <Toaster>
              at `top-center`, which after adding this global one
              caused every toast to render twice (top + bottom).
              Default position keeps the historical placement so
              existing pages behave identically. Individual toasts
              can still opt into a different spot via
              `toast.custom(..., { position: "bottom-center" })` —
              the `EnquiryToast` rich card does exactly that. */}
          <Toaster
            position="top-center"
            richColors
            expand={false}
            visibleToasts={3}
          />
        </div>
      </AudioGuideProvider>
    </MusicPlayerProvider>
  );
};

export default Layout;
